import { observer } from 'mobx-react';
import React from 'react';
import { ordersStore } from 'src/mobx/ordersStore';
import { IOrderProduct, IOrderProductModifierOption } from '../../../../../types/orders';
import { formatPrice, getTranslate } from '../../../../../utils/formatter';
import './style.scss';

interface IProps {
  option: IOrderProductModifierOption;
  productQuantity: IOrderProduct['quantity'];
}

export const OrderOption: React.FC<IProps> = observer(({ option, productQuantity }) => {
  return (
    <div className="details-modifier">
      <div className="details-modifier-name">
        <div className="details-modifier-option">
          {getTranslate(option.name)}
          {option.quantity && option.quantity > 1 ? (
            <span className="details-modifier-option-quantity">x{option.quantity}</span>
          ) : null}
        </div>
      </div>
      <div className="details-modifier-price">
        {ordersStore.formatPrice(option.price * option.quantity * productQuantity)}
      </div>
    </div>
  );
});
